import axios from 'axios';
import AxiosConfiguration from '@/classes/AxiosConfiguration';
import { LockModel } from '@/types';
import { BuiltInListConfigurationModel, BuiltInListUpdateResultModel, BuiltInListItemModel } from '@/types/models/listMaintenance';
import { ListMaintenanceConfigurationModel } from '@/types/models/listMaintenance/ListMaintenanceConfigurationModel';

const ListMaintenanceApiUrl = 'listMaintenanceConfiguration';

export const ListMaintenanceService = {
  async getListMaintenanceServiceConfiguration(): Promise<ListMaintenanceConfigurationModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ListMaintenanceApiUrl}`);
    return response.data;
  },
  async getBuiltInListLockAsync(listId: number): Promise<LockModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ListMaintenanceApiUrl}/lock/${listId}`);
    return response.data;
  },
  async getBuiltInListItemsAsync(listId: number): Promise<BuiltInListConfigurationModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ListMaintenanceApiUrl}/builtIn/${listId}`);
    return response.data;
  },
  async createBuiltInListItemAsync(listItem: BuiltInListItemModel): Promise<BuiltInListUpdateResultModel> {
    const response = await axios.post(`${ListMaintenanceApiUrl}/listitem`, listItem);
    return response.data;
  },
  async updateBuiltInListItemAsync(listItem: BuiltInListItemModel): Promise<BuiltInListUpdateResultModel> {
    const response = await axios.put(`${ListMaintenanceApiUrl}/listitem`, listItem);
    return response.data;
  },
  async deleteMafListItemsAsync(listId: number, builtInListItemsDelete: number[]) {
    const response = await AxiosConfiguration.axiosWithErrorPage.delete(`${ListMaintenanceApiUrl}/listItem/${listId}`, { data: builtInListItemsDelete });
    return response.data;
  }
};
